import { render, staticRenderFns } from "./field-setup.vue?vue&type=template&id=61878c8b&scoped=true&"
import script from "./field-setup.vue?vue&type=script&lang=js&"
export * from "./field-setup.vue?vue&type=script&lang=js&"
import style0 from "./field-setup.vue?vue&type=style&index=0&id=61878c8b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61878c8b",
  null
  
)

export default component.exports